module.exports = __webpack_public_path__ + "static/media/Option3ProfPic.81edc7cc.png";